
const officers = [
  {
    position: '会長',
    name: '岡村 芳和',
    organization: 'ひまわり薬局',
    icon: 'ri-user-star-line'
  },
  {
    position: '副会長',
    name: '東 耕世',
    organization: '三洋薬局',
    icon: 'ri-user-line'
  },
  {
    position: '副会長',
    name: '師玉 龍一',
    organization: 'しだま調剤薬局',
    icon: 'ri-user-line'
  },
  {
    position: '副会長',
    name: '平井 聡',
    organization: '平井薬局',
    icon: 'ri-user-line'
  }
];

export function About() {
  return (
    <section id="about" className="py-16 sm:py-24 md:py-32 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <p className="text-amber-500 text-xs sm:text-sm font-semibold tracking-widest uppercase mb-3 sm:mb-4">
            ABOUT US
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 px-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            奄美薬剤師会について
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mb-12 sm:mb-16 md:mb-20">
          {officers.map((officer, index) => (
            <div
              key={index}
              className="bg-slate-800/50 backdrop-blur-sm rounded-2xl p-5 sm:p-6 border border-slate-700/50 hover:border-amber-500/50 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl cursor-pointer group"
            >
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-500/10 rounded-full flex-shrink-0">
                  <i className={`${officer.icon} text-2xl sm:text-3xl text-teal-400`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-white font-bold text-base sm:text-lg mb-1">{officer.position}</p>
                  <p className="text-gray-300 text-sm sm:text-base font-medium">{officer.name}</p>
                  <p className="text-gray-400 text-xs sm:text-sm truncate">{officer.organization}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-slate-800/30 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 border border-slate-700/30">
            <p className="text-white text-sm sm:text-base md:text-lg leading-relaxed" style={{ lineHeight: '1.9' }}>
              奄美薬剤師会では、奄美市内で開催される<strong className="text-teal-400 font-semibold">学術講演会</strong>に関して、日本薬剤師研修センターの「<strong className="text-teal-400 font-semibold">集合研修の認定単位</strong>」の申請及び日本薬剤師会主催の生涯学習支援システム「<strong className="text-teal-400 font-semibold">JPAL</strong>」の研修コードの申請を行っています。研修のお知らせは、奄美薬剤師会ホームページ上のカレンダーで行っています。ご利用ください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
